// 基类数据
import store from "@/store/index";
import { generate_guid } from "@/rlMxModules/utils/util";
import { delRlModules } from "@/mixins/LiteModuleDb.js";
import { revokeRollback } from "@/rlMxModules/operate/revokeRollback.js";
import { resetRlModules } from "@/mixins/LiteModuleDb.js";

class rlBaseData {
  constructor() {
    this.No_ = null;
    this.Guid = generate_guid();
    this.StdFlrGuid = store.state.globalData.rl_stdFlr_id; //标准层guid
    this.classTypeName = "rlEntity";
    this.m_groupName = ""; //分组名称
  }

  //对象数据初始化/赋值
  initData(obj) {
    this.StdFlrGuid = obj.StdFlrGuid;
    this.Guid = obj.Guid ? obj.Guid : this.Guid;
  }

  //用于撤销回退
  reDraw(obj) {
    this.StdFlrGuid = obj.StdFlrGuid;
    this.Guid = obj.Guid ? obj.Guid : this.Guid; //Guid需要保持不变，因为撤销回退数组中都是原始GUID
    this.Color = obj.Color;
  }

  /**
   * 保存编辑撤销数据
   * 如果不是重做操作，并且不是文本、线条、实体或圆形图形，则调用撤销回退函数
   */
  saveEditRevokeData() {
    store.commit("globalData/setDatabaseStore", {
      type: "edit_before",
      obj: this,
    });
    if (
      !store.state.globalData.isReDo &&
      store.state.globalData.canAddRawStep &&
      this.classTypeName != "rlText" &&
      this.classTypeName != "rlLine" &&
      this.classTypeName != "rlEntity" &&
      this.classTypeName != "rlCircle"
    ) {
      store.commit("globalData/setRevokeDataStore", {
        type: "edit_before",
        obj: this.getDrawData(),
      });
      // await revokeRollback(
      //   this,
      //   store.state.globalData.drawStep,
      //   "edit_before"
      // );
    }
  }

  // 删除
  erase() {
    //将删除数据添加到数据库存储数组中
    store.commit("globalData/setDatabaseStore", {
      type: "delete",
      obj: this,
    });
    // await delRlModules(
    //   this.classTypeName,
    //   store.state.globalData.rl_stdFlr_id,
    //   this.Guid
    // );
    // //
    if (
      !store.state.globalData.isReDo &&
      store.state.globalData.canAddRawStep &&
      this.classTypeName != "rlText" &&
      this.classTypeName != "rlLine" &&
      this.classTypeName != "rlEntity" &&
      this.classTypeName != "rlCircle"
    ) {
      store.commit("globalData/setRevokeDataStore", {
        type: "delete",
        obj: this.getDrawData(),
      });
      // await revokeRollback(this, store.state.globalData.drawStep, "delete");
    }

    store.commit("rlEntData/delEntityData", {
      Guid: this.Guid,
      classTypeName: this.classTypeName,
    });
    // rlAppObj.rlMxDatabase.getGroup(this.m_groupName)?.delete(this);
    // super.erase();
    // this.setNeedUpdateDisplay();
  }

  //数据修改更新
  updateThisObj(obj) {
    // await resetRlModules(
    //   this.classTypeName,
    //   store.state.globalData.rl_stdFlr_id,
    //   this.Guid,
    //   this.getDataBase()
    // );

    //将更新数据添加到数据库存储数组中
    store.commit("globalData/setDatabaseStore", {
      type: "edit_after",
      obj: this,
    });

    store.commit("rlEntData/editEntityData", this);

    if (
      !store.state.globalData.isReDo &&
      store.state.globalData.canAddRawStep &&
      this.classTypeName != "rlText" &&
      this.classTypeName != "rlLine" &&
      this.classTypeName != "rlEntity" &&
      this.classTypeName != "rlCircle"
    ) {
      store.commit("globalData/setRevokeDataStore", {
        type: "edit_after",
        obj: this.getDrawData(),
      });
      // await revokeRollback(this, store.state.globalData.drawStep, "edit_after");
    }
  }
  // 返回图形源数据--用于后台数据存储
  getDataBase() {
    return {
      // ID: this.ID,
      // No_: this.No_,
      Guid: this.Guid,
      StdFlrGuid: store.state.globalData.rl_stdFlr_id,
    };
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    return {
      objID: this.mcDbId,
      classTypeName: this.classTypeName,
      Color: this.Color,
      Guid: this.Guid,
    };
  }
}
export default rlBaseData;
